import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class NavigationService {
  openMenu: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  scrollToTopButton = false;
  public scrollToTop!: any;
  public about!: any;
  public help!: any;
  public tariff!: any;

  constructor() {
  }
}
